export default __webpack_public_path__ + "side_and_sill_channels.png";